import React from 'react'
import { Col, Container, FormControl, Row, Button } from 'react-bootstrap'
import Section from '../Section'
import TitleSection from '../TitleSection'
import { ContactForm, ContactIcon, ContactItem ,ContactImage} from './Style'

export default function Contact(props) {
    return (
        <Section bg="white">
            <Container>
                {props.noTitle ? null : (
                    <TitleSection text="Contact As" center />
                )}
                <Row>
                    <Col lg={6}>
                        <ContactItem>
                            <ContactIcon><i className="fas fa-map-marker-alt"></i></ContactIcon>
                            <h6>Our Address</h6>
                            <p>A108 Adam Street, New York, NY 535022</p>
                        </ContactItem>
                    </Col>
                    <Col lg={3}>
                        <ContactItem>
                            <ContactIcon><i className="fas fa-envelope"></i></ContactIcon>
                            <h6>Email Us</h6>
                            <p>Educate@gmail.com</p>
                        </ContactItem>
                    </Col>
                    <Col lg={3}>
                        <ContactItem>
                            <ContactIcon><i className="fas fa-phone-alt"></i> </ContactIcon>
                            <h6>Call Us</h6>
                            <p>+ 1245 1667 6788</p>
                        </ContactItem>
                    </Col>
                    <Col lg={6} >
                        <ContactImage src={"images/Contact.svg"} alt="" />
                    </Col>
                    <Col lg={6} >
                        <ContactForm>
                            <Row>
                                <Col lg={6}>
                                    <FormControl placeholder="First name" />
                                </Col>
                                <Col lg={6}>
                                    <FormControl placeholder="First name" />
                                </Col>
                                <Col lg={12}>
                                    <FormControl placeholder="First name" />
                                </Col>
                                <Col lg={12}>
                                    <FormControl as="textarea" placeholder="First name" />
                                </Col>
                            </Row>
                            <Button variant="primary" type="submit">
                                Send Message
                            </Button>
                        </ContactForm>
                    </Col>
                </Row>
            </Container>
        </Section>
    )
}
